import { render, staticRenderFns } from "./BMobileCart.vue?vue&type=template&id=64adbac8&scoped=true"
import script from "./BMobileCart.vue?vue&type=script&setup=true&lang=ts"
export * from "./BMobileCart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BMobileCart.vue?vue&type=style&index=0&id=64adbac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64adbac8",
  null
  
)

export default component.exports